import { Card, CardContent } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { serviceSharingTests } from "./testDefinitions";

export const ServiceSharingSection = ({ testResults }) => {
  return (
    <Card className="shadow-none mb-4">
      <CardContent className="pt-4">
        <TestSubsection 
          title="Cross-Company Service Sharing"
          tests={serviceSharingTests}
          results={testResults.serviceSharing}
        />
      </CardContent>
    </Card>
  );
};
